import { Component, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ContractCostTypeEnum } from "@enums/contractCostType.enum";
import { ContractIntervalEnum } from "@enums/contractInterval.enum";
import { ContractPaymentTypeEnum } from "@enums/contractPaymentType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Contract } from "@interfaces/models/contract.interface";
import { ContractPayment } from "@interfaces/models/contractPayment.interface";
import { PaymentTerm } from "@interfaces/models/paymentTerm.interface";
import { PurchaseLog } from "@interfaces/models/purchaseLog.interface";
import { Supplier } from "@interfaces/models/supplier.interface";
import { PurchaseLogFileLink } from "@interfaces/purchaseLogFileLink.interface";
import { Site } from "@interfaces/site.interface";
import { SupplierContact } from "@interfaces/supplierContact.interface";
import { ContractService } from "@services/contract.service";
import { ContractPaymentService } from "@services/contractPayment.service";
import { FileService } from "@services/file.service";
import { PaymentTermService } from "@services/paymentTerm.service";
import { PurchaseLogService } from "@services/purchaseLog.service";
import { SiteService } from "@services/site.service";
import { SupplierService } from "@services/supplier.service";
import { SupplierContactService } from "@services/supplierContact.service";
import { ToastService } from "angular-toastify";
import { DxDataGridComponent } from "devextreme-angular";
import { Guid } from "guid-typescript";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "contracts-id",
	styleUrls: ["contracts-id.css"],
	templateUrl: "contracts-id.html"
})
export class ContractsIdAdminComponent {
	@ViewChild("gridContainer", { static: false }) dataGrid!: DxDataGridComponent;
	addDocumentButtonOptions = { onClick: () => this.addNewDocumentPopup(), text: "Add Document", type: "default", useSubmitBehavior: false }
	changes: any = [];
	contact: SupplierContact = new SupplierContact();
	contacts: SupplierContact[] = [];
	contractCostTypes: any;
	contractIntervalTypes: any;
	contractPaymentTypes: any;
	contractPayments: ContractPayment[] = [];
	contracts: Contract[] = [];
	createEnabled = true;
	documents: PurchaseLogFileLink[] = [];
	editEnabled = true;
	editRowKey: any = null;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	item: Contract = new Contract();
	itemType = "Contract";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	paymentTerms: PaymentTerm[] = [];
	popupAddButtonOptions: any;
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupContact: SupplierContact = new SupplierContact();
	popupContractPayment: ContractPayment = new ContractPayment();
	popupDocument: PurchaseLogFileLink = new PurchaseLogFileLink();
	popupSupplier: Supplier = new Supplier();
	popupTitle = "";
	popupVisible = false;
	purchaseLogs: PurchaseLog[] = [];
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	screenMode = "";
	sites: Site[] = [];
	suppliers: Supplier[] = [];
	title: string = "View " + this.itemType;

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private fileService: FileService, private itemService: ContractService, private contractPaymentService: ContractPaymentService, private paymentTermService: PaymentTermService, private purchaseLogService: PurchaseLogService, private siteService: SiteService, private supplierContactService: SupplierContactService, private supplierService: SupplierService) {
		this.getPaymentTerms();
		this.getSites();
		this.getSuppliers();

		this.contractCostTypes = GetPropertiesFromEnum(ContractCostTypeEnum);
		this.contractIntervalTypes = GetPropertiesFromEnum(ContractIntervalEnum);
		this.contractPaymentTypes = GetPropertiesFromEnum(ContractPaymentTypeEnum);

		this.route.params.subscribe((params) => {
			if (params.id != "create") {
				if (params.id.split("_").length > 1) {
					this.getItem(params.id.split("_")[0], "edit");
					this.edit();
				} else {
					this.getItem(params.id, "view");
				}
			} else {
				this.create();
				this.buildButtons("create");
			}
		});

		this.deleteContractPayment = this.deleteContractPayment.bind(this);
		this.deleteDocumentLink = this.deleteDocumentLink.bind(this);
		this.downloadFileLink = this.downloadFileLink.bind(this);
		this.editContractPaymentPopup = this.editContractPaymentPopup.bind(this);
		this.uploadDocument = this.uploadDocument.bind(this);
		this.viewPurchaseLogRow = this.viewPurchaseLogRow.bind(this);
	}

	addNewContact() {
		this.supplierContactService.createSingle(this.popupContact)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.getContacts(this.item.supplierId, true);
				},
				(err: any) => console.log(err)
			);
	}

	addNewContactPopup() {
		if (this.item.supplierId === undefined || this.item.supplierId === null || this.item.supplierId < 1) {
			alert("No Supplier Selected - Please select a supplier before adding a contact.");
			return;
		}
		this.popupContact = new SupplierContact();
		this.popupContact.supplierId = this.item.supplierId;
		this.popupTitle = "Add New Contact";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewContact(), text: "Add Contact" };
	}

	addNewContractPayment() {
		this.popupContractPayment.costDelta = this.popupContractPayment.actualCost - this.popupContractPayment.estimatedCost;
		this.contractPaymentService.createSingle(this.popupContractPayment)
			.subscribe(
				() => {
					this.toastService.success("Payment created");
					this.getContractPayments(this.item.id);
					this.closePopup();
					this.popupContractPayment = new ContractPayment();
				},
				(err: any) => console.log(err)
			);
	}

	addNewContractPaymentPopup() {
		this.popupTitle = "Add New Contract Payment";
		this.popupContractPayment = new ContractPayment();
		this.popupContractPayment.contractId = this.item.id;
		this.popupContractPayment.estimatedCost = this.item.intervalValue;
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewContractPayment(), text: "Add Payment" };
	}

	addNewDocument() {
		if (this.popupDocument === null || this.popupDocument === undefined || this.popupDocument.fileName === "") {
			alert("Please upload a document");
			return;
		}
		this.documents.push(this.popupDocument);
		this.popupDocument = new PurchaseLogFileLink();

		if (this.title === "Create New " + this.itemType) {
			this.createItem();
		} else {
			this.updateItem();
		}
		this.closePopup();
	}

	addNewDocumentPopup() {
		this.popupDocument = new PurchaseLogFileLink();
		this.popupTitle = "Add New Document";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewDocument(), text: "Add Document" };
	}

	addNewSupplier() {
		this.supplierService.createSingle(this.popupSupplier)
			.subscribe(
				() => {
					this.getSuppliers(true);

					this.popupVisible = false;
					this.popupSupplier = new Supplier();
				},
				(err: any) => console.log(err)
			);
	}

	addNewSupplierPopup() {
		this.popupSupplier = new Supplier();
		this.popupTitle = "Add New Supplier";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewSupplier(), text: "Add Supplier" };
	}

	buildButtons(mode: string) {
		this.screenMode = mode;
		this.headerPrimaryButtons = [];
		this.headerSecondaryButtons = [];
		this.headerTertiaryButtons = [];

		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [
				{ method: "calculateIntervalCount", text: "Calculate Total Intervals" },
				{ method: "calculateIntervalValue", text: "Calculate Interval Value" }
			];
			this.headerTertiaryButtons = [
				{ method: "addNewContactPopup", text: "Add New Contact" },
				{ method: "addNewSupplierPopup", text: "Add New Supplier" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [
				{ method: "calculateIntervalCount", text: "Calculate Total Intervals" },
				{ method: "calculateIntervalValue", text: "Calculate Interval Value" }
			];
			this.headerTertiaryButtons = [
				{ method: "addNewContactPopup", text: "Add New Contact" },
				{ method: "addNewSupplierPopup", text: "Add New Supplier" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [
				{ method: "addNewContractPaymentPopup", text: "Add Payment" },
				{ method: "duplicateContract", text: "Duplicate" }
			];
		}
	}

	calculateContractPaymentDueDate() {		
		this.paymentTermService.getDueDate(this.item.paymentTermId, this.popupContractPayment.invoiceDate)
			.subscribe(
				(res: any) => {
					this.popupContractPayment.paymentDate = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	calculateIntervalCount() {		
		this.itemService.calculateIntervalCount(this.item.startDate, this.item.endDate, this.item.intervalType)
			.subscribe(
				(res: any) => {
					this.item.totalIntervals = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	calculateIntervalValue() {
		this.item.intervalValue = parseFloat((this.item.contractValue / this.item.totalIntervals).toFixed(4));
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	closePopup() {
		this.popupVisible = false;
	}

	contractPaymentPopupFormDataChanged(args: any) {
		switch (args.dataField) {
			case "estimatedCost":
			case "actualCost":
				this.popupContractPayment.costDelta = this.popupContractPayment.actualCost - this.popupContractPayment.estimatedCost;
				break;
		}
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.item.documents = JSON.stringify(this.documents);

		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Created " + this.itemType);
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	deleteContractPayment(e: any) {
		if (confirm("Are you sure you want to delete this payment?") == false) {
			return;
		}

		this.contractPaymentService.deleteSingleById(e.row.data.id)
			.subscribe(
				() => {
					this.toastService.success("Payment deleted!");
					this.getContractPayments(this.item.id);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
		return false;
	}

	deleteDocumentLink(e: any) {
		const index = this.documents.findIndex(d => d.lookupId === e.row.data.lookupId);
		this.documents.splice(index, 1);

		return false;
	}

	downloadFileLink(e: any) {
		const lookupId = Guid.parse(e.row.data.lookupId);
		this.fileService.downloadFile(lookupId).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", e.row.data.fileName);
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
		return false;
	}

	duplicateContract() {
		const duplicate = new Contract({
			autoRenew: this.item.autoRenew,
			contractValue: this.item.contractValue,
			coolingPeriodDays: this.item.coolingPeriodDays,
			costType: this.item.costType,
			intervalType: this.item.intervalType,
			intervalValue: this.item.intervalValue,
			maximumSpend: this.item.maximumSpend,
			minimumSpend: this.item.minimumSpend,
			name: this.item.name + " (Copy)",
			paymentTermId: this.item.paymentTermId,
			paymentType: this.item.paymentType,
			supplierContactId: this.item.supplierContactId,
			supplierId: this.item.supplierId,
			terminationDays: this.item.terminationDays,
			totalIntervals: this.item.totalIntervals,
		});
		this.itemService.createSingle(duplicate).subscribe(
			(res: any) => {
				this.toastService.success("Contract duplicated!");
				this.router.navigate([`${this.returnUrl}/${res.response.lookupId}_edit`]);
			},
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	editContractPayment() {
		this.popupContractPayment.costDelta = this.popupContractPayment.actualCost - this.popupContractPayment.estimatedCost;
		this.contractPaymentService.updateSingleById(this.popupContractPayment.id, this.popupContractPayment)
			.subscribe(
				() => {
					this.toastService.success("Payment updated");
					this.getContractPayments(this.item.id);
					this.closePopup();
					this.popupContractPayment = new ContractPayment();
				},
				(err: any) => console.log(err)
			);
	}

	editContractPaymentPopup(e: any) {
		const contractPaymentId = e.row.data.id;
		this.popupContractPayment = this.contractPayments.filter(p => p.id == contractPaymentId)[0];
		this.popupTitle = "Edit Contract Payment";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.editContractPayment(), text: "Save Changes" };
		return false;
	}

	formDataChanged(args: any) {
		switch (args.dataField) {
			case "supplierId":
				this.getContacts(args.value);
				break;
		}
	}

	getContacts(supplierId: number, setNewestContact = false) {
		this.supplierContactService.getContactsBySupplierId(supplierId)
			.subscribe(
				(res: any) => {
					this.contacts = res.response;

					if (setNewestContact) {
						this.item.supplierContactId = this.contacts[this.contacts.length - 1].id;
					}
				},
				(err) => console.log(err)
			);
	}

	getContractPayments(contractId: number) {
		this.contractPaymentService.forContract(contractId)
			.subscribe(
				(res: any) => {
					this.contractPayments = res.response;
				},
				(err) => console.log(err)
			);
	}

	getItem(lookupId: Guid, mode: string) {
		this.itemService.getSingleByLookupId(lookupId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.documents = JSON.parse(this.item.documents);
					this.getContacts(this.item.supplierId);
					this.getPurchaseLogs(this.item.id);
					this.getContractPayments(this.item.id);
					this.buildButtons(mode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getPaymentTerms() {
		this.paymentTermService.getAll()
			.subscribe(
				(res: any) => {
					this.paymentTerms = res.response.items;
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getPurchaseLogs(contractId: number) {
		this.purchaseLogService.getByContractId(contractId)
			.subscribe(
				(res: any) => {
					this.purchaseLogs = res.response;
				},
				(err) => console.log(err)
			);
	}

	getSites() {
		this.siteService.getAll()
			.subscribe(
				(res: any) => {
					this.sites = res.response.items;
					this.sites.sort((a, b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getSuppliers(setNewestSupplier = false) {
		this.supplierService.getAll()
			.subscribe(
				(res: any) => {
					this.suppliers = res.response.items;

					if (setNewestSupplier) {
						this.item.supplierId = this.suppliers[this.suppliers.length - 1].id;
					}

					this.suppliers.sort((a, b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	updateItem() {
		this.item.documents = JSON.stringify(this.documents);

		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	uploadDocument(file: File) {
		const containerName = "contractfiles";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		// Add Mime Type key when mime types are decided upon...
		// uploadData.append("mimeTypeKey", "CADFileMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.popupDocument.lookupId = res.response[0].lookupId;
					this.popupDocument.fileName = res.response[0].name;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Document Upload Failed - Please ensure you are uploading a valid file");
				}
			);
	}

	viewPurchaseLogRow(e: any) {
		this.router.navigate([`/admin/purchaseLogs/${e.row.data.lookupId}`]);
	}
}